// Material Dashboard 2 PRO React base styles
import borders from "assets/theme/base/borders";
import typography from "assets/theme/base/typography";

const { borderRadius } = borders;
const { size } = typography;

const menuItem = {
  styleOverrides: {
    root: {
      minHeight: "unset",
      padding: "6px 16px",
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      transition: "background-color 300ms ease, color 300ms ease",
    },
  },
};

export default menuItem;
